import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { PageHeader } from '@/components/layout/PageHeader';
import { ContentWrapper } from '@/components/layout/ContentWrapper';
import { FileText } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  section: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title, section }) => {
  return (
    <ContentWrapper>
      <PageHeader
        title={title}
        subtitle={`${section} module`}
        breadcrumbs={[
          { label: section },
          { label: title, isActive: true },
        ]}
      />

      <Card className="bg-white border border-gray-200 shadow-sm">
        <CardContent className="p-12 text-center">
          <div className="mx-auto w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
            <FileText className="h-8 w-8 text-blue-500" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
          <p className="text-gray-500 max-w-md mx-auto">
            This page is part of the {section} module. Full implementation will connect to the ClaimsIQ backend API.
          </p>
        </CardContent>
      </Card>
    </ContentWrapper>
  );
};

export default PlaceholderPage;